import { FC } from 'react';
import { WrapperFieldTypeProps } from '@app/shared/ui/ui-kit/FormField/Types';
import classNames from 'classnames';

import styles from './FormField.module.scss';

export const WrapperField: FC<WrapperFieldTypeProps> = ({ children, isFocus, error, type, showSelectItem }) => {
  return (
    <div
      className={classNames(styles.Container, {
        [styles.Focus]: isFocus,
        [styles.isError]: error,
        [styles.TextArea]: type === 'textarea',
        [styles.OpenSelect]: showSelectItem,
      })}
    >
      {children}
    </div>
  );
};
